import React from "react";
import "./partnumbercard.scss";
import { Iprops } from "./partnumberinterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import GetimageBaseURL from "../../../assets/images";
import helperfunctions from "../../../utils/helperfunctions";
import QuantityColumn from "../Quantity";
import BranchDetails from "../../DropShip/Fulfilment/branchDetails";
import { selectors as headerSelector } from "../../../state/features/header";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { DataTable, ModalPopup, TreeviewDropdown } from "../../CommonComponent";
import Loader from "../../Loader";
import moment from 'moment';
import { useSelector } from "react-redux";
import {
    selectors as orderTrackingSelector
} from "../../../state/features/orderdetail";

const LocationImage = (row: any, openGmap: any) => {
    return <td><span aria-hidden="true" className="fa fa-map-marker gmapLink" onClick={() => { openGmap(row?.dataItem) }}></span></td>
}

const DetailComponent = (props: any) => {
    const { address1, city, stateName, postalCode, countryName, phone } = props?.dataItem ?? {}
    const { t } = useTranslation();
    return (
        <>
            <div>{address1}</div>
            <div> {`${city ?? ''}, ${stateName ?? ''} - ${postalCode ?? ''} ${countryName ?? ''}`}</div>
            <div> {t(RESOURCE.MyK_Label_SC_Phone)}: {phone ?? ' - '}</div>
        </>
    )}

const RefundableCorePrice = (props: any) => {
    const { t } = useTranslation();
    return (props.corePrice > 0 ? <div className="refundable-core">{(t(RESOURCE.MyK_Label_SC_Refundable_Core_Price)).replace("{0}", "$"+ helperfunctions.formatAmount(props?.corePrice))}</div> : null);
}

const getWarningMessage = (item: any) => {
    const warningMessage = item?.hazardousDetail ?? "";
    let firstTextSection = warningMessage;
    const firstIndex = warningMessage.indexOf("www");
    let linkSection = null;
    let secondSection = null;
    if (firstIndex > -1) {
        const linkEnd = warningMessage.indexOf(" ", firstIndex);
        firstTextSection = warningMessage.slice(0, firstIndex);

        if (linkEnd == -1) {
            linkSection = warningMessage.slice(firstIndex)
        }
        else {
            linkSection = warningMessage.slice(firstIndex, linkEnd);
            secondSection = warningMessage.slice(linkEnd);
        }
    }
    return ((warningMessage && warningMessage != "") && <div className="partInfoMsg">
        <span className="fa fa-info-circle infoIcon"></span>
        <span className="ml-2">
            <span dangerouslySetInnerHTML={{ __html: firstTextSection }} />
            {linkSection && <a href={"https://" + linkSection} target="_blank">{linkSection}</a>}
            {secondSection && <span dangerouslySetInnerHTML={{ __html: secondSection }} />}
        </span>
    </div>)
}

const DealerAvailabilityPopUp = (props: any) => {
    const { delearBranchList, DetailComponent, columns, closeDealerAvailablity, onOrderingBranchChange, selectedBranch } = props?.props ?? {};
    const { t } = useTranslation();
    const dealerOptionList = delearBranchList?.data?.length ? [{ value: 'Select', title: 'Select Ordering Branch' }, ...delearBranchList?.data ?? []] : [{ value: 'Select', title: 'Select Ordering Branch' }];
    const branchList =  delearBranchList?.data?.filter((s: any) => !s.excludedFromTransfer && !s.isSelectedBranch) ?? [];
    return <ModalPopup
        ShowModalPopupFooter={true}
        ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Dealer_Availability)}
        ModalPopupType="medium"
        closeModalPopup={() => closeDealerAvailablity(false)}
        ModalPopupName={'partNumberCard'}
    >
        <>
            {delearBranchList?.loading && <Loader />}
            <div className="label">{t(RESOURCE.MyK_Label_SC_Ordering_Branch)} <span className="fa fa-info-circle infoIcon"></span></div>
            <TreeviewDropdown
                treeData={dealerOptionList}
                showSearch={true}
                className='SelectOrderingBranch'
                dropdownClassName={'dropdownListContainer noNested'}
                placeholder={t(RESOURCE.MyK_Label_SC_Select_Ordering_Branch)}
                onChange={(value: any, title: any) => onOrderingBranchChange(value, title)}
                value={(!delearBranchList?.loading && dealerOptionList?.length) ? selectedBranch?.BranchCode : ''}
            />
            <div className="infoMsg">{t(RESOURCE.MyK_Label_SC_Dealer_Availability_Info)}</div>
            <div className="dealerAvailability">
                <DataTable
                storageKey={"dealerAvailabilityInfo"} enableFiltering={true}
                    data={branchList}
                    dataColumn={columns}
                    dataItemKey="distributorBranchCode"
                    className='dealerAvailability'
                    defaultPageSize={branchList?.length ?? 10}
                    DetailRow={true}
                    DetailComponent={DetailComponent}
                    pagination={false}
                />
            </div>
            <div className="footerbtn">
                <button className="clsBtn" title={t(RESOURCE.MyK_Label_Close)} onClick={() => closeDealerAvailablity(true)}><span className="fa fa-times mr-2"></span>{t(RESOURCE.MyK_Label_Close)}</button>
            </div>
        </>
    </ModalPopup>
}

const PartNumberCard = (props: Iprops) => {
    const { cartsDetails, onViewDiscountDetails } = props;
    const imgUrl = GetimageBaseURL();
    const defaultProductImage = imgUrl + "ecommercecategoryimages/NoImage-Big.png";
    const { t } = useTranslation();
    const { headercurrentuser: { isGuestUser }, enableOrderTracking, showReturnableFlag }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
        enableOrderTracking: orderTrackingSelector.enableOrderTracking(state),
        showReturnableFlag: orderTrackingSelector.showReturnableFlag(state)
    }));
    
    const getTotalAvailabilityCount = (availabilityList: any) => {
        const sumOfQty = availabilityList?.length > 0 ? availabilityList.reduce((total: any, availability: any) => {
            return total + availability.qty;
        }, 0) : 0;
        return sumOfQty;
    }

    const convertUtcTimeToLocalTime = (time: any) =>
    {
        if (time) {
            let date = new Date();
            let timeData = moment(time, ["hh:mm A"]).format("HH:mm");
            let hour = parseInt(timeData?.split(":")[0] ?? "00");
            let minute = parseInt(timeData?.split(":")[1] ?? "00");
            let utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute, 0,));
            let localtime = moment(utcDate).format("HH:mm");
            let timeWithAmPm = moment(localtime, ["HH:mm"]).format("hh:mm A");
            return (t(RESOURCE.Myk_SC_OrderByDuration)).replace("{0}", timeWithAmPm);
        }
        else {
            return "";
        }
    }

    function partNumberNavigation(item: any) {
        props.partNumberRedirect(item.partNumber)
    }

    const columns = [{
        field: "branchLocation",
        title: t(RESOURCE.MyK_Label_Branch_Location),
        columnMenu: 'ColumnMenu',
        sortable: true
    },
    {
        field: "gMapUrl",
        title: t(RESOURCE.MyK_Label_See_On_Map),
        sortable: false,
        cell: (row: any) => LocationImage(row, props?.openGmap)
    },
    {
        field: "branchAvailability",
        title: t(RESOURCE.MyK_Grid_Quantity),
        columnMenu: 'ColumnMenu',
        sortable: true,
        filter: "numeric"
    }]

    const getPartCardFirstSection = (item: any) => {
        return ((item?.substituteParts?.length > 0) ?
                <div className="partnumber_cart-card Session__partnumber_cart-card mb-4" key=''>
                    <div className="add_part-LeftWrapper">
                        <div className="partnumber_header">
                            <span className="checkbox_wrapper">
                            <input type="checkbox" checked={props.childCheckboxes[item.cartDetailId]}
                                onChange={() => props.handleChildChange(item.cartDetailId)} />
                            <Tooltip anchorElement="target" position="bottom">
                                {getPartNumberSection(item)}
                            </Tooltip>
                            </span>
                            <span className="partnumber_header-description">
                                {t(RESOURCE.MyK_Label_ShoppingCart_Unavailable)}
                            </span>
                            <span className='quantitySec'>
                                <div className="quantity-label">{t(RESOURCE.MyK_Label_ShoppingCart_Quantity)}:</div>
                            <div><QuantityColumn cartDetailId={item?.cartDetailId} quantity={item.quantity} partNumber={item.partNumber} childPartNumber={null} updateCartQuantity={props.updateCartQuantity} /></div>
                            </span>
                        </div>
                    </div>
                </div> : null
        )
    }

    const isNewPart = (part :any) => {
        return (part.partLastRefreshed == "0001-01-01T00:00:00" && part.isValidKomatsuProduct !== false && part.isValidKomatsuProduct !== true);
    }

    const getItemTotalClass = (isContactDealer: any) => {
        return (isContactDealer ? "unit_Price-value" : "ItemTotal-value");
    }

    const getPartNumberSection = (item: any) => {
        return (item?.isPartAvailableInPIM
            ? <span className="partnumber_HD" onKeyDown={() => { }} onClick={() => partNumberNavigation(item)} title={item.partNumber} > {item.partNumber}</span >
            : <span className="partnumber_HD_noLink" title={item.partNumber}>{item.partNumber}</span>
        );
    }

    const getPartImage = (partImage: any) => {
        return (((partImage ?? "") == "") ? defaultProductImage : partImage);
    }

    const getBranchClass = (type :any) => {
        return `Branch ${(type === 'DA') ? 'hyperLink' : ''}`;
    }

    const getItemTotal = (isInitialAdd: any, item: any) => {
        if (!isInitialAdd) {
            const promoPart = item?.promoPartTotal?.length > 0 && item?.promoPartTotal[0]?.promoDetails?.length > 0 ? item?.promoPartTotal[0] : null;
            if (promoPart && !item.isContactDealer) {
                return (
                    <div className={getItemTotalClass(item.isContactDealer)}
                        style={{ color: `${promoPart?.promoColorCode ?? 'black'}` }}>
                        {promoPart?.afterDiscountAmount > 0 &&
                            <>
                                {(promoPart?.afterDiscountAmount != promoPart?.beforeDiscountAmount) && <span className="itemTotal-linethrough">{helperfunctions.getUnitPrice(promoPart.beforeDiscountAmount, t, item.isContactDealer)}</span>}
                                <span onClick={() => onViewDiscountDetails(item?.partNumber)} className="itemTotal-promoprice">{helperfunctions.getUnitPrice(promoPart.afterDiscountAmount, t, item.isContactDealer)}</span>
                            </>
                        }
                    </div>
                )
            }

            return (<div className={getItemTotalClass(item.isContactDealer)}>
                <span>{helperfunctions.getUnitPrice(item.itemTotal, t, item.isContactDealer)}</span>
            </div>)
        }

        return null;
    }

    const getPartCardSecondSection = (item: any) => {
        const isInitialAdd = localStorage.getItem("isRefreshedAfterAdd") === "false";
        return (
            <div className="SupperSessionPartnumberWrapper">
                {item?.substituteParts?.map((child: any, index: any) =>
                (
                    <div className="mb-4" key={child.partNumber}>
                        <div className="shopping_warnning-msg">
                            {index == 0 ?
                                <span>
                                    {t(RESOURCE.MyK_Label_SC_SuperSession)}: {t(RESOURCE.MyK_Grid_Part_Number)} {item.partNumber} {t(RESOURCE.MyK_Label_SC_SuperSession_Info)} {child.partNumber}
                                </span> :
                                <span>
                                    {t(RESOURCE.MyK_Label_SC_SuperSession)}: {t(RESOURCE.MyK_Grid_Part_Number)} {item?.substituteParts[index - 1].partNumber} {t(RESOURCE.MyK_Label_SC_SuperSession_Info2)} {child.partNumber} {t(RESOURCE.MyK_Label_SC_SuperSession_Info3)}
                                </span>
                            }
                        </div>

                        <div className="partnumber_cart-card" key={child.partNumber}>
                            <div className="add_part-LeftWrapper">
                                <div className="partnumber_header">
                                    <span className="checkbox_wrapper">
                                        <Tooltip anchorElement="target" position="bottom">
                                            {getPartNumberSection(child)}
                                        </Tooltip>
                                    </span>
                                    <span className="partnumber_header-description">
                                        {child.description}
                                    </span>
                                </div>
                                <div className="partnumber-content">
                                    <div className="partnumber_productImg">
                                        <img src={getPartImage(child?.partImage)}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                if (currentTarget.src != defaultProductImage) {
                                                    currentTarget.src = defaultProductImage;
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="manufacturer_modal-wrapper">
                                        <div className="manufacturer_wrapper manufacturerTitleWrap" >
                                            <label onClick={() => {
                                                props.handleManufactureOption(child?.manufacturer);
                                                props.setMachineManufactureModel({ childPartNumber: child.partNumber, partNumber: item.partNumber, manufacturer: child?.manufacturer, machine: child?.machine, cartDetailId: item?.cartDetailId });
                                                props.toggleManufacturePopupClick();
                                            }} onKeyDown={() => { }}
                                                title={t(RESOURCE.MyK_Grid_Manufacturer)}>
                                                {t(RESOURCE.MyK_Grid_Manufacturer)}:
                                            </label>
                                            <div className="manufacturer_Value">
                                                {child?.manufacturer?.name}
                                            </div>
                                        </div>
                                        {!isGuestUser && <div className="mahcine_modal-wrapper">
                                            <label onClick={() => {
                                                props.setMachineManufactureModel({ childPartNumber: child.partNumber, partNumber: item.partNumber, manufacturer: child?.manufacturer, machine: child?.machine, cartDetailId: item?.cartDetailId });
                                                props.toggleMachinePopupClick();
                                            }}
                                                onKeyDown={() => { }}
                                                title={t(RESOURCE.MyK_Label_ShoppingCart_Machine_Model)}>
                                                {t(RESOURCE.MyK_Label_ShoppingCart_Machine_Model)}:
                                            </label>
                                            <div className="mahcine_modal_Value">
                                                {child?.machine?.modelDisplay}
                                            </div>
                                        </div>}
                                        {showReturnableFlag && <div className="retunable-wrapper">
                                            <label onKeyDown={() => { }} onClick={props.ReturnableOnClick} title={t(RESOURCE.MyK_Label_ShoppingCart_Returnable)}>{t(RESOURCE.MyK_Label_ShoppingCart_Returnable)}:</label>
                                            <span className="retunable_Value ml-1">{child.returnable ? "Yes" : "No"}</span>
                                        </div>}
                                    </div>
                                    <div className="partnumber_availability">
                                        <div className="availability_row-HD">
                                            <span className="qty">{t(RESOURCE.MyK_Label_ShoppingCart_Qty)}.</span>
                                            <span className="Branch">{t(RESOURCE.MyK_Label_ShoppingCart_Branch)}</span>
                                            <span className="Availability">{t(RESOURCE.MyK_Label_ShoppingCart_Availability)}
                                                <Tooltip anchorElement="target" position="top">
                                                    <span className="fa fa-info-circle availabilityInfo" title={t(RESOURCE.MyK_Label_ShoppingCart_Availability_info)}></span>
                                                </Tooltip></span>
                                        </div>
                                        {(!isNewPart(child)) && <>
                                            {
                                                child?.availability.map((items: any) => (
                                                    items?.isContactDealer ?
                                                        (<div className="availability_row-content" key={items?.type + "contactdealer"}>
                                                            <span className="qty value">{items?.availabilityCount}</span>
                                                            <span className="contactBranch">{''}</span>
                                                            <span className="contactAvailabilty hyperLink" aria-hidden="true" title={t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability)} onClick={props?.onClickContactDealer}>{t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability)}</span>
                                                        </div>) :
                                                        (<div className="availability_row-content" key={items?.type}>
                                                        <span className="qty value">{items?.availabilityCountStr}</span>
                                                        <span aria-hidden="true" className={getBranchClass(items?.type)} onClick={() => props?.dealerOnClick(items, child)}>{items?.branch}</span>
                                                        <span className="Availability">{items?.availabilityLeadTime ?? ''}</span>
                                                        </div>)
                                                ))
                                            }
                                            {(!props?.isFetchingCartItems && !props?.refreshCartRequiredParts.includes(item.partNumber)) && <div className="placeOrderInfo">
                                                {convertUtcTimeToLocalTime(child?.orderCutOffTime)}
                                            </div>}
                                        </> 
                                        }
                                    </div>
                                </div>
                                {(child.recommendationCount > 0) &&
                                    <div
                                        className={"SeeRecommendations"}
                                        title={t(RESOURCE.MyK_Label_ShoppingCart_See_Recommedations)}
                                        onClick={() => props.productRecommendationPopupClick(child)}
                                        onKeyDown={() => { }}
                                    >
                                        {t(RESOURCE.MyK_Label_ShoppingCart_See_Recommedations)} ({child.recommendationCount})
                                    </div>}
                            </div>
                            <div className="add_part-RightWrapper">
                                <div className="unit_Price-label">{t(RESOURCE.MyK_Label_ShoppingCart_Unit_Price)}:</div>
                                <div className="unit_Price-value">
                                    <span>{isNewPart(child) ? "" : helperfunctions.getUnitPrice(child.unitPrice, t, child.isContactDealer)}</span>
                                </div>
                                <RefundableCorePrice corePrice={child.corePrice} />
                                <div className="quantity-label">{t(RESOURCE.MyK_Label_ShoppingCart_Quantity)}:</div>
                                <div className="quantity-value">
                                    <span title={t(RESOURCE.MyK_Label_SC_Partlist_Decrease)} className="quantity_minus disabled">-</span>
                                    <span><input type="text" className="textfield" disabled value={child.quantity}></input></span>
                                    <span title={t(RESOURCE.MyK_Label_SC_Partlist_Increase)} className="quantity_plus disabled">+</span>
                                </div>
                                <div className="ItemTotal-label">{t(RESOURCE.MyK_Label_ShoppingCart_Item_Total)}:</div>
                                {getItemTotal(isInitialAdd, child)}
                                {getEstimatedShippingVisibility(child)}
                            </div>
                        </div>
                        {(child?.isValidKomatsuProduct === false) && <div className="partInfoMsg">
                            <span className="fa fa-info-circle infoIcon"></span><span className="ml-2">{t(RESOURCE.MyK_Label_SP_Cd_Info)}</span>
                        </div>}
                        {(child?.hazardousFlag) && getWarningMessage(child)}
                        {props?.refreshCartRequiredParts.includes(item.cartDetailId) && !cartsDetails?.cart?.isRestrictPartsCheck && <div className="partInfoWarnMsg">
                            <span className="fa fa-exclamation-circle infoIcon"></span><span className="ml-2">{t(RESOURCE.MyK_Label_SP_Cd_RefreshRequiredWarning)}</span>
                        </div>
                        }
                    </div>
                ))}
            </div>
        )
    }

    const getPartCardThirdSection = (item: any) => {
        const isInitialAdd = localStorage.getItem("isRefreshedAfterAdd") === "false";
        return (
            <div className="NormalPartnumberWrapper mb-4">
                <div className="partnumber_cart-card" key={item.partNumber}>
                    <div className="add_part-LeftWrapper">
                        <div className="partnumber_header">
                            <span className="checkbox_wrapper">
                                <input type="checkbox" checked={props.childCheckboxes[item.cartDetailId]}
                                    onChange={() => props.handleChildChange(item.cartDetailId)} />
                                <Tooltip anchorElement="target" position="bottom">
                                    {getPartNumberSection(item)}
                                </Tooltip>
                            </span>
                            <span className="partnumber_header-description">
                                {item.description}
                            </span>
                        </div>
                        <div className="partnumber-content">
                            <div className="partnumber_productImg">
                                <img src={getPartImage(item?.partImage)}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        if (currentTarget.src != defaultProductImage) {
                                            currentTarget.src = defaultProductImage;
                                        }
                                    }}
                                />
                            </div>
                            <div className="manufacturer_modal-wrapper">
                                <div className="manufacturer_wrapper manufacturerTitleWrap" >
                                    <label onClick={() => {
                                        props.handleManufactureOption(item?.manufacturer);
                                        props.setMachineManufactureModel({ childPartNumber: "", partNumber: item.partNumber, manufacturer: item?.manufacturer, machine: item?.machine, cartDetailId: item?.cartDetailId });
                                        props.toggleManufacturePopupClick();
                                    }} onKeyDown={() => { }} title={t(RESOURCE.MyK_Grid_Manufacturer)}>
                                        {t(RESOURCE.MyK_Grid_Manufacturer)}:
                                    </label>
                                    <div className="manufacturer_Value">
                                        {item?.manufacturer?.name}
                                    </div>
                                </div>
                                {!isGuestUser && < div className="mahcine_modal-wrapper">
                                    <label onKeyDown={() => { }} onClick={() => {
                                        props.setMachineManufactureModel({ childPartNumber: "", partNumber: item.partNumber, manufacturer: item?.manufacturer, machine: item?.machine, cartDetailId: item?.cartDetailId });
                                        props.toggleMachinePopupClick();
                                    }}
                                        title={t(RESOURCE.MyK_Label_ShoppingCart_Machine_Model)}>
                                        {t(RESOURCE.MyK_Label_ShoppingCart_Machine_Model)}:
                                    </label>
                                    <div className="mahcine_modal_Value">
                                        {item?.machine?.modelDisplay}
                                    </div>
                                </div>}
                                {showReturnableFlag && <div className="retunable-wrapper">
                                    <label onClick={props.ReturnableOnClick} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Returnable)}>{t(RESOURCE.MyK_Label_ShoppingCart_Returnable)}:</label>
                                    <span className="retunable_Value ml-1">{item.returnable ? "Yes" : "No"}</span>
                                </div>}
                            </div>
                            <div className="partnumber_availability">
                                <div className="availability_row-HD">
                                    <span className="qty">{t(RESOURCE.MyK_Label_ShoppingCart_Qty)}.</span>
                                    <span className={getTotalAvailabilityCount(item?.availability) > 0 ? "Branch" : "contactBranch"}>{t(RESOURCE.MyK_Label_ShoppingCart_Branch)}</span>
                                    <span className={getTotalAvailabilityCount(item?.availability) > 0 ? "Availability" : "contactAvailabilty"}>{t(RESOURCE.MyK_Label_ShoppingCart_Availability)}
                                        <Tooltip anchorElement="target" position="top">
                                            <span className="fa fa-info-circle availabilityInfo" title={t(RESOURCE.MyK_Label_ShoppingCart_Availability_info)}></span>
                                        </Tooltip></span>
                                </div>
                                {(!isNewPart(item)) && <>
                                    {
                                        item?.availability.map((items: any) => (
                                            items?.isContactDealer ? (
                                                <div className="availability_row-content" key={items.type + "contactdealer"}>
                                                    <span className="qty value">{items?.availabilityCount}</span>
                                                    <span className={t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability) ? "contactBranch" : "Branch"}>{''}</span>
                                                    <span aria-hidden="true" className={t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability) ? "contactAvailabilty hyperLink" : "Availability hyperLink"} title={t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability)} onClick={props?.onClickContactDealer}>{t(RESOURCE.MyK_Label_SC_Contact_Dealer_Availability)}</span>
                                                </div>
                                            ) :
                                            (<div className="availability_row-content" key={items.type}>
                                                <span className="qty value">{items?.availabilityCountStr}</span>
                                                <span aria-hidden="true" className={getBranchClass(items?.type)} onClick={() => props?.dealerOnClick(items, item)}>{items?.branch}</span>
                                                <span className="Availability">{items?.availabilityLeadTime ?? ''}</span>
                                            </div>)
                                        ))
                                    }
                                    {(!props?.isFetchingCartItems && !props?.refreshCartRequiredParts.includes(item.partNumber)) && <div className="placeOrderInfo">
                                        {convertUtcTimeToLocalTime(item?.orderCutOffTime)}
                                    </div>}
                                </> 
                                }
                            </div>
                        </div>
                        {(item.recommendationCount > 0) &&
                            <div
                                className={"SeeRecommendations"}
                                title={t(RESOURCE.MyK_Label_ShoppingCart_See_Recommedations)}
                                onClick={() => props.productRecommendationPopupClick(item)} onKeyDown={() => { }}>
                                {t(RESOURCE.MyK_Label_ShoppingCart_See_Recommedations)} ({item.recommendationCount})
                            </div> }
                    </div>
                    <div className="add_part-RightWrapper">
                        <div className="unit_Price-label">{t(RESOURCE.MyK_Label_ShoppingCart_Unit_Price)}:</div>
                        <div className="unit_Price-value">
                            <span>{isNewPart(item) ? "" : helperfunctions.getUnitPrice(item.unitPrice, t, item.isContactDealer)}</span>
                        </div>
                        <RefundableCorePrice corePrice={item.corePrice} />
                        <div className="quantity-label">{t(RESOURCE.MyK_Label_ShoppingCart_Quantity)}:</div>
                        <div><QuantityColumn cartDetailId={item?.cartDetailId} quantity={item.quantity} partNumber={item.partNumber} childPartNumber={null} updateCartQuantity={props.updateCartQuantity} /></div>
                        <div className="ItemTotal-label">{t(RESOURCE.MyK_Label_ShoppingCart_Item_Total)}:</div>
                        {getItemTotal(isInitialAdd, item)}
                        {getEstimatedShippingVisibility(item)}
                    </div>
                </div>
                {(item?.isValidKomatsuProduct === false) && <div className="partInfoMsg">
                    <span className="fa fa-info-circle infoIcon"></span><span className="ml-2">{t(RESOURCE.MyK_Label_SP_Cd_Info)}</span>
                </div>}
                {(item?.hazardousFlag) && getWarningMessage(item)}
                {props?.refreshCartRequiredParts.includes(item.cartDetailId) && !cartsDetails?.cart?.isRestrictPartsCheck && <div className="partInfoWarnMsg">
                    <span className="fa fa-exclamation-circle infoIcon"></span><span className="ml-2">{t(RESOURCE.MyK_Label_SP_Cd_RefreshRequiredWarning)}</span>
                </div>
                }
            </div>
        )
    }

    const getEstimatedShippingVisibility = (part: any) => {
        return (enableOrderTracking && !props.isPunchOutUser && !part?.isContactDealer &&
            part.unitPrice > 0 && part?.isValidKomatsuProduct) ?
            <div className="estimate_Shipping" title={t(RESOURCE.MyK_Label_ShoppingCart_Estimate_Shipping)} onKeyDown={() => { }} onClick={() => props.estOnClick(part.partNumber)}>{t(RESOURCE.MyK_Label_ShoppingCart_Estimate_Shipping)}</div>
            : null;
    }

    return (
        <>
            {props.partnumberchild.map((item: any) => (
                <>
                    {getPartCardFirstSection(item)}
                    <>
                        {(item?.substituteParts?.length > 0) ?
                            getPartCardSecondSection(item)
                            :
                            getPartCardThirdSection(item)
                        }
                    </>
                </>
            ))}
            {
                props.branchDetailsModal ?
                    <BranchDetails
                        onhandleClose={props.onhandleClose}
                        fullfilmentBranchInfo={props?.branchInfo}
                    /> : null
            }
            {props?.dealerView &&
                <DealerAvailabilityPopUp props={{
                    onOrderingBranchChange: props?.onOrderingBranchChange,
                    delearBranchList: props?.delearBranchList,
                    DetailComponent, columns,
                    closeDealerAvailablity: props?.closeDealerAvailablity,
                    selectedBranch: props?.selectedBranch
                }} />
            }
        </>
    );
};

export default PartNumberCard;
